import { NavLink } from 'react-router'
import { Bus, Grid2x2, Home, Menu } from 'lucide-react'
import { cn } from '../../lib/cn'

const ABAS = [
  { para: '/', rotulo: 'Início', Icone: Home, exato: true },
  { para: '/categorias', rotulo: 'Categorias', Icone: Grid2x2, exato: false },
  { para: '/excursoes', rotulo: 'Excursões', Icone: Bus, exato: false },
  { para: '/mais', rotulo: 'Mais', Icone: Menu, exato: false },
] as const

export function TabBar() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-hairline bg-white/95 backdrop-blur-sm"
      style={{ paddingBottom: 'var(--safe-bottom)' }}
      aria-label="Navegação principal"
    >
      <ul className="mx-auto flex h-(--altura-tabbar) max-w-xl">
        {ABAS.map(({ para, rotulo, Icone, exato }) => (
          <li key={para} className="flex-1">
            <NavLink
              to={para}
              end={exato}
              className={({ isActive }) =>
                cn(
                  'relative flex h-full flex-col items-center justify-center gap-1 transition-colors',
                  isActive ? 'text-verde-600' : 'text-ink-soft hover:text-navy-500',
                )
              }
            >
              {({ isActive }) => (
                <>
                  {/* Marcador no topo da aba ativa: so a cor do icone e um sinal
                      fraco demais para quem tem baixa visao de contraste. */}
                  <span
                    aria-hidden
                    className={cn(
                      'absolute top-0 h-0.5 w-9 rounded-b-full transition-opacity',
                      isActive ? 'bg-verde-500 opacity-100' : 'opacity-0',
                    )}
                  />
                  <Icone size={21} strokeWidth={isActive ? 2.3 : 1.75} aria-hidden />
                  <span className={cn('text-[10px]', isActive ? 'font-bold' : 'font-medium')}>
                    {rotulo}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
